import DatePickerRange from 'components/PeriodSelection/DatePickerRange';
import { format } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';


export function EditSongWorkOrigin(songSplitsDetail: any) {

    const [showtab, setShowTab] = useState(1);
    const [showSubtab, setShowSubTab] = useState(4);

    return (
        <>
            <div className='ws-12'>

                <div className="alert alert-success ng-binding ng-hide" data-ng-show="showWorkOriginSuccessSaveMsg">Recording
                    Details
                    saved
                    successfully
                </div>

                <div className="alert alert-danger ng-binding ng-hide">There was a problem submitting your request, one or more fields are missing or incorrect. </div>

                <div className="form-format ws-12 m0 ng-hide" data-ng-show="workOriginDisplay">
                    <fieldset className="scheduler-border ws-6" style={{ minHeight: "315px" }}>
                        <legend className="scheduler-border"><h2 style={{ color: "#47529d;" }}><i className="fa fa-sticky-note-o"></i> Work Origin Details</h2></legend>
                        <div className="ws-12">
                            <div className="ws-6">
                                <div className="form-format m0 mt">
                                    <label className="control-label " id="ProductionTitle">Production Title</label>
                                    <div className="label-entries">
                                        <input type="text" name="ProductionTitle" placeholder="Production Title" data-ng-model="workOriginDetails.productionTitle" />
                                    </div>
                                </div>
                                <div className="form-format m0 mt">
                                    <label className="control-label " id="ProductionNumber">Production Number</label>
                                    <div className="label-entries">
                                        <input type="text" name="ProductionNumber" placeholder="Production Number" data-ng-model="workOriginDetails.productionNumber" />
                                    </div>
                                </div>

                                <div className="form-format m0 mt">
                                    <label className="control-label " id="ProductionYear">Production Year</label>
                                    <div className="label-entries">
                                        <input type="text" name="ProductionYear" placeholder="Production Year" data-ng-model="workOriginDetails.productionYear" />
                                    </div>
                                </div>
                            </div>
                            <div className="ws-6">
                                <div className="form-format m0 mt">
                                    <label className="control-label " id="type">Intended Purpose</label>
                                    <div className="label-entries">
                                        <select data-ng-options="type.code as type.description for type in loadSongFormValuesList | filter:{referenceType:'IntentedPurpose'}" ng-model="workOriginDetails.intendedPurpose" name="IntendedPurpose" className="ng-pristine ng-untouched ng-valid"><option value="" className=""> Choose Intended Purpose</option><option value="0" label="Commercial / Jingle / Trailer">Commercial / Jingle / Trailer</option><option value="1" label="Film">Film</option><option value="2" label="General Usage">General Usage</option><option value="3" label="Library Work">Library Work</option><option value="4" label="Multimedia">Multimedia</option><option value="5" label="Radio">Radio</option><option value="6" label="Television">Television</option><option value="7" label="Theatre">Theatre</option><option value="8" label="Video">Video</option></select>
                                    </div>
                                </div>
                                <div className="form-format m0 mt">
                                    <label className="control-label " id="EpisodeTitle">Episode Title</label>
                                    <div className="label-entries">
                                        <input type="text" name="EpisodeTitle" placeholder="Episode Title" data-ng-model="workOriginDetails.episodeTitle" />
                                    </div>
                                </div>

                                <div className="form-format m0 mt">
                                    <label className="control-label " id="EpisodeNumber">Episode Number</label>
                                    <div className="label-entries">
                                        <input type="text" name="EpisodeNumber" placeholder="Episode Number" data-ng-model="workOriginDetails.episodeNumber" />
                                    </div>
                                </div>


                            </div>
                        </div>
                    </fieldset>

                    <fieldset className="scheduler-border w-49 pull-right" style={{ minHeight: "315px" }}>
                        <legend className="scheduler-border"><h2 style={{ color: "#47529d;" }} ><i className="fa fa-sticky-note-o"></i> Other Work Origin Details</h2></legend>
                        <div className="ws-12">
                            <div className="ws-6">

                                <div className="form-format m0 mt">
                                    <label className="control-label " id="type">AVI Society Code</label>
                                    <div className="label-entries">
                                        <select ng-model="workOriginDetails.aVISocietyCode" name="AVISocietyCode" className="ng-pristine ng-untouched ng-valid">
                                            <option value="" className=""> Choose AVI Society Code</option>
                                            <option value="0" label="DP">DP</option>

                                        </select>
                                    </div>
                                </div>

                                <div className="form-format m0 mt">
                                    <label className="control-label " id="AudioVisualNumber">Audio Visual Number</label>
                                    <div className="label-entries">
                                        <input type="text" name="AudioVisualNumber" placeholder="Audio Visual Number" data-ng-model="workOriginDetails.audioVisualNumber" />
                                    </div>
                                </div>
                                <div className="form-format m0 mt">
                                    <label className="control-label " id="Library">Library</label>
                                    <div className="label-entries">
                                        <input type="text" name="Library" placeholder="Library" data-ng-model="workOriginDetails.library" />
                                    </div>
                                </div>
                                <div className="form-format m0 mt">
                                    <label className="control-label " id="CutNumber">Cut Number</label>
                                    <div className="label-entries">
                                        <input type="text" name="CutNumber" placeholder="Cut Number" data-ng-model="workOriginDetails.cutNumber" />
                                    </div>
                                </div>

                            </div>
                            <div className="ws-6">
                                <div className="form-format m0 mt">
                                    <label className="control-label " id="VISAN">VISAN</label>
                                    <div className="label-entries">
                                        <input type="text" name="VISAN" placeholder="VISAN" data-ng-model="workOriginDetails.vISAN" />
                                    </div>
                                </div>
                                <div className="form-format m0 mt">
                                    <label className="control-label " id="CDIdentifier">CD Identifier</label>
                                    <div className="label-entries">
                                        <input type="text" name="CDIdentifier" placeholder="CD Identifier" data-ng-model="workOriginDetails.cDIdentifier" />
                                    </div>
                                </div>

                                <div className="form-format m0 mt">
                                    <label className="control-label " id="BLTVR">BLTVR</label>
                                    <div className="label-entries">
                                        <input type="text" name="BLTVR" placeholder="BLTVR" data-ng-model="workOriginDetails.bLTVR" />
                                    </div>
                                </div>
                                <div className="form-format m0 mt">
                                    <label className="control-label " id="CheckDigit">Check Digit</label>
                                    <div className="label-entries">
                                        <input type="text" name="CheckDigit" placeholder="Check Digit" data-ng-model="workOriginDetails.checkDigit" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>


            </div>
        </>
    )

}